@if (listing().features) {
  <div
    class="overflow-hidden rounded-lg bg-white dark:bg-gray-900/20 shadow-sm text-gray-900 dark:text-gray-100 px-4 py-5 sm:px-6 sm:py-6"
  >
    <app-listing-details-accordion
      accordionId="home-features"
      [expandable]="remainingFeatures().length > 0"
      [title]="listing().saleType === 'homesite' ? 'Homesite Features' : 'Home Features'"
    >
      <ul preview role="list" class="divide-y divide-gray-100 dark:divide-gray-700 mt-4">
        @for (feature of topFeatures(); track feature) {
          <li class="relative flex justify-between gap-x-2 py-2 sm:px-6 lg:px-2">
            <div class="flex min-w-0 gap-x-0">
              <div class="min-w-0 flex-auto">
                <p>{{ feature }}</p>
              </div>
            </div>
          </li>
        }
      </ul>

      @if (remainingFeatures().length) {
        <ul
          role="list"
          class="divide-y divide-gray-100 dark:divide-gray-700 border-t border-gray-100 dark:border-gray-700"
        >
          @for (feature of remainingFeatures(); track feature) {
            <li class="relative flex justify-between gap-x-2 py-2 sm:px-6 lg:px-2">
              <div class="flex min-w-0 gap-x-0">
                <div class="min-w-0 flex-auto">
                  <p>{{ feature }}</p>
                </div>
              </div>
            </li>
          }
        </ul>
      }
    </app-listing-details-accordion>
  </div>
}
